import type { WorkbenchUpdateSummary } from '../workbenchUpdate'
import WorkbenchChangesRow from './WorkbenchChangesRow'

interface WorkbenchChangesPanelProps {
  summary: WorkbenchUpdateSummary
}

/**
 * The top of the composer while the "Chart updated" tab is up: a line on why
 * the tab is here, and what changed — the same row the sent card carries, so the
 * person sees exactly what goes out before sending it. The box for an optional
 * message sits below it, and Send to AI in the composer's chrome row, where the
 * send button does.
 */
export default function WorkbenchChangesPanel({ summary }: WorkbenchChangesPanelProps) {
  return (
    <div className="flex flex-col gap-2 text-body">
      <p className="text-caption text-text-secondary">
        {summary.first
          ? "The AI hasn't seen your chart yet. Send it so the AI can work from what you drew."
          : 'Your chart changed since the AI last saw it. Send the changes so the AI can update your strategy.'}
      </p>
      <WorkbenchChangesRow summary={summary} />
    </div>
  )
}
